import React, { useState } from 'react';

import { DEFAULT_SEARCH_CRITERIA } from './constants/DefaultSearchCriteria';

interface DataTableContextValue {
    searchCriteria: any;
    setSearchCriteria: React.Dispatch<React.SetStateAction<any>>;
}

const defaultValue: DataTableContextValue = {
    searchCriteria: DEFAULT_SEARCH_CRITERIA,
    setSearchCriteria: () => { },
};

export const DataTableContext = React.createContext<DataTableContextValue>(defaultValue);

export const DataTableProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [searchCriteria, setSearchCriteria] = useState<any>(DEFAULT_SEARCH_CRITERIA);

    return (
        <DataTableContext.Provider value={{ searchCriteria, setSearchCriteria }}>
            {children}
        </DataTableContext.Provider>
    );
};
